import React, { useState, useEffect, useRef } from 'react';
import Layout from '../components/layout/Layout';
import SEO from '../components/SEO';
import { 
  FileText, Package, PackageX, CreditCard, Wallet, Utensils, BedDouble, Shirt, 
  HeartPulse, ShieldCheck, AlertTriangle, MapPinned, XCircle, RotateCcw, Ban, 
  ShieldAlert, Baby, PawPrint, MessageSquare, Database, Globe, Scale, Anchor, 
  Ship, Users, Compass, FileCheck, CalendarX, Lock, Cigarette, Dumbbell, 
  CheckCircle2, ChevronRight, List, ArrowUp
} from 'lucide-react';

const sections = [
  { 
    id: 'objet', num: '1', title: 'Objet', icon: FileText,
    content: (
      <p>Les présentes conditions régissent les ventes de croisières en catamaran proposées par Sognudimare sur le site <a href="https://www.sognudimare.com" className="text-[#2A9D8F] font-medium hover:underline" target="_blank" rel="noopener noreferrer">www.sognudimare.com</a>. Toute réservation implique l'acceptation intégrale des CGV.</p>
    )
  },
  {
    id: 'prestations-incluses', num: '2', title: 'Prestations incluses', icon: Package,
    content: (
      <p>Hébergement en cabine double, navigation selon itinéraire prévu, pension complète, boissons incluses (hors champagne), utilisation du matériel de bord, équipage professionnel.</p>
    )
  },
  {
    id: 'prestations-non-incluses', num: '3', title: 'Prestations non incluses', icon: PackageX,
    content: (
      <p>Acheminement jusqu'au port d'embarquement, assurances personnelles, dépenses personnelles, excursions optionnelles non mentionnées.</p>
    )
  },
  {
    id: 'reservation-acompte', num: '4', title: 'Réservation et acompte', icon: CreditCard,
    content: (
      <>
        <p>Réservation confirmée après signature du bon de commande et versement d'un acompte de <strong className="text-[#1D3557]">30 %</strong>.</p>
        <p className="mt-2">Solde dû au plus tard <strong className="text-[#1D3557]">60 jours</strong> avant départ.</p>
      </>
    )
  },
  {
    id: 'caisse-de-bord', num: '5', title: 'Caisse de bord', icon: Wallet,
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Incluse dans le tarif indiqué sur le site internet, payable dans son intégralité par virement ou lien sécurisé fourni par l'Organisateur.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Montant pré-établi pour chaque croisière et indiqué sur le bon de commande ou l'offre commerciale.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Permet de couvrir les taxes, droits portuaires et clearances.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Si non acquittée dans les délais, l'embarquement pourra être refusé.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Forfaitaire : aucun supplément ne peut être exigé et aucun remboursement ne pourra être demandé.</span></li>
      </ul>
    )
  },
  {
    id: 'restauration', num: '6', title: 'Restauration et boissons', icon: Utensils,
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Trois repas par jour inclus (petit-déjeuner, déjeuner, dîner), buffet ou service à table.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Tous les plats sont préparés et servis à bord du navire.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Sognudimare fait appel à des prestataires locaux et en circuits courts afin d'assurer des produits frais et de qualité.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Il est <strong className="text-[#1D3557]">obligatoire</strong> de signaler toute allergie ou intolérance alimentaire.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Boissons incluses : vins, rhum, cocktails, bières, jus, cafés, thés, sodas. <strong className="text-[#1D3557]">Champagne non fourni.</strong></span></li>
      </ul>
    )
  },
  {
    id: 'cabines', num: '7', title: 'Confort et cabines', icon: BedDouble,
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Attribution des cabines par ordre d'inscription, demandes spécifiques à mentionner sur le bon de commande.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Chaque salle d'eau dispose de douche, lavabo et WC.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Nettoyage complet du navire avant chaque embarquement.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong className="text-[#1D3557]">Caution de 500 euros par cabine</strong> exigée avant embarquement.</span></li>
      </ul>
    )
  },
  {
    id: 'linge-entretien', num: '8', title: 'Linge, entretien et consignes', icon: Shirt,
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Chaque passager reçoit 1 grande serviette, 1 petite serviette et 1 fouta.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Equipement de literie complet fourni : draps, plaid ou couverture, coussins, housses.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Chaque cabine doit être tenue propre par le passager. Le ménage des cabines n'est pas effectué par l'hôtesse.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Bagages limités à des sacs souples ou valises compactes.</span></li>
      </ul>
    )
  },
  {
    id: 'sante', num: '9', title: 'Santé et aptitude physique', icon: HeartPulse,
    content: (
      <div className="space-y-3">
        <p>Le Passager doit être en bonne santé pour participer à la croisière.</p>
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
          <p className="text-amber-800 text-sm font-medium">Toute maladie, traitement en cours ou condition médicale particulière doit être signalée à l'Organisateur lors de la réservation. En cas d'omission, la responsabilité de Sognudimare ne pourra être engagée.</p>
        </div>
      </div>
    )
  },
  {
    id: 'assurance', num: '10', title: 'Assurance', icon: ShieldCheck,
    content: (
      <div className="bg-[#2A9D8F]/5 border border-[#2A9D8F]/20 rounded-xl p-4">
        <p className="text-slate-700 font-medium">Souscription d'une assurance voyage et annulation <strong className="text-[#1D3557]">fortement conseillée</strong>.</p>
      </div>
    )
  },
  {
    id: 'responsabilite', num: '11', title: 'Responsabilité', icon: AlertTriangle,
    content: (
      <p>L'Organisateur ne peut être tenu responsable des cas de force majeure (météo, grèves, avaries, décisions portuaires) ni des vols, pertes ou dommages aux effets personnels. Il est fortement recommandé de protéger les appareils électroniques dans des housses étanches. Le capitaine déconseille d'emporter des objets de valeur ou d'importantes sommes en espèces.</p>
    )
  },
  {
    id: 'modification-itineraire', num: '12', title: "Modification d'itinéraire & adaptation changement climatique", icon: MapPinned,
    content: (
      <div className="space-y-4">
        <p>Le Capitaine est seul habilité à modifier l'itinéraire pour raisons de sécurité ou conditions météorologiques difficiles. <strong className="text-[#1D3557]">Aucun remboursement dû.</strong></p>
        <div className="bg-gradient-to-r from-[#2A9D8F]/10 to-[#2A9D8F]/5 border-l-4 border-[#2A9D8F] rounded-r-xl p-5">
          <div className="flex items-start gap-3">
            <CheckCircle2 className="h-6 w-6 text-[#2A9D8F] shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold text-[#1D3557] mb-2">Engagement SOGNUDIMARE — Adaptation au changement climatique</p>
              <p className="text-slate-700">
                En cas de <strong>conditions météorologiques difficiles annoncées avant l'embarquement</strong> (alertes Météo-France, vents soutenus supérieurs à Force 7, mer dangereuse, alerte de sécurité significative), le Capitaine et l'Armateur SOGNUDIMARE pourront proposer aux passagers de <strong className="text-[#2A9D8F]">reporter leur croisière jusqu'à 12 mois</strong> sur une croisière équivalente, sous réserve de disponibilité et <strong>sans frais supplémentaires</strong>.
              </p>
              <p className="text-slate-600 italic text-sm mt-2">
                SOGNUDIMARE est l'un des rares croisiéristes à s'adapter activement aux changements climatiques afin de garantir à ses passagers une expérience sécurisée, confortable et de qualité.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'annulation-client', num: '13', title: 'Annulation par le client', icon: XCircle,
    content: (
      <div className="space-y-4">
        <p>Barème d'indemnités selon la date d'annulation :</p>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse rounded-xl overflow-hidden text-sm">
            <thead>
              <tr className="bg-[#1D3557] text-white">
                <th className="text-left py-3 px-4 font-semibold">Délai avant départ</th>
                <th className="text-right py-3 px-4 font-semibold">Frais d'annulation</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-slate-100 bg-white">
                <td className="py-3 px-4">Jusqu'à 90 jours</td>
                <td className="py-3 px-4 text-right font-semibold text-[#2A9D8F]">25 %</td>
              </tr>
              <tr className="border-b border-slate-100 bg-slate-50">
                <td className="py-3 px-4">De 89 à 60 jours</td>
                <td className="py-3 px-4 text-right font-semibold text-[#C4956A]">50 %</td>
              </tr>
              <tr className="border-b border-slate-100 bg-white">
                <td className="py-3 px-4">De 59 à 30 jours</td>
                <td className="py-3 px-4 text-right font-semibold text-[#C4724F]">75 %</td>
              </tr>
              <tr className="bg-red-50">
                <td className="py-3 px-4">Moins de 30 jours / non-présentation</td>
                <td className="py-3 px-4 text-right font-bold text-red-600">100 %</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
          <p className="text-amber-800 text-sm"><strong>Cas particulier :</strong> Navires réservés en exclusivité — majoration de 20 % sur les frais d'annulation ci-dessus.</p>
        </div>
        <div className="space-y-3 mt-4">
          <h4 className="font-semibold text-[#1D3557]">Modification de date</h4>
          <div className="grid gap-3">
            <div className="bg-slate-50 rounded-lg p-3 border border-slate-100">
              <p className="text-sm font-semibold text-[#1D3557] mb-1">+ de 90 jours avant le départ</p>
              <p className="text-sm text-slate-600">Avancement : +5 % | Report : +1 %/jour (min. 21j, max. 35j)</p>
            </div>
            <div className="bg-slate-50 rounded-lg p-3 border border-slate-100">
              <p className="text-sm font-semibold text-[#1D3557] mb-1">89 à 45 jours</p>
              <p className="text-sm text-slate-600">Avancement : +20 % | Report : +40 %</p>
            </div>
            <div className="bg-red-50 rounded-lg p-3 border border-red-100">
              <p className="text-sm font-semibold text-red-700 mb-1">Moins de 45 jours</p>
              <p className="text-sm text-red-600">Traitée comme une annulation</p>
            </div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'annulation-organisateur', num: '14', title: "Annulation par l'organisateur", icon: RotateCcw,
    content: (
      <div className="space-y-4">
        <p>En cas d'annulation par l'Organisateur, le client se voit proposer en priorité <strong className="text-[#1D3557]">le report de sa croisière jusqu'à 12 mois</strong> sur une croisière équivalente sans frais supplémentaires.</p>

        <p>À défaut d'acceptation du report par le client, un <strong className="text-[#1D3557]">remboursement des sommes versées</strong> sera effectué <strong className="text-[#1D3557]">dans un délai maximum de dix (10) mois</strong> à compter de la date de notification écrite de l'annulation ou de la croisière concernée.</p>

        <div className="bg-slate-50 border border-slate-200 rounded-xl p-5">
          <p className="text-sm font-semibold text-[#1D3557] mb-2">Justification du délai de remboursement</p>
          <p className="text-sm text-slate-700 leading-relaxed">Ce délai est expressément accepté par le Client à la signature du contrat. Il est justifié par le caractère <strong>irrévocable et non-restituable</strong> de l'ensemble des charges d'exploitation engagées par l'Organisateur préalablement à la croisière, notamment : frais d'affrètement et de mise à disposition du navire, frais portuaires et de mouillage, salaires et charges sociales de l'équipage, primes d'assurance, achats de provisions de bord, taxes touristiques et environnementales. Ces décaissements ayant été définitivement réalisés en amont et ne pouvant faire l'objet d'aucune restitution au profit de l'Organisateur, ce délai est nécessaire pour préserver la trésorerie d'exploitation et garantir la continuité de l'activité de l'Organisateur, sans porter atteinte aux droits du Client. Cette modalité ne constitue pas une renonciation au remboursement, mais un aménagement temporel de son versement.</p>
        </div>

        <div className="bg-[#FFF7ED] border border-[#FED7AA] rounded-xl p-5">
          <p className="font-semibold text-[#9A3412] mb-2.5">Cas de force majeure dégageant l'Organisateur de toute responsabilité (liste non exhaustive) :</p>
          <div className="bg-white/70 border border-[#FED7AA] rounded-lg p-3.5 mb-3.5">
            <p className="text-sm text-[#9A3412]"><strong>Engagement SOGNUDIMARE :</strong> Dans <strong>tous</strong> les cas de force majeure listés ci-dessous, <strong>le report de la croisière jusqu'à 12 mois sera systématiquement établi pour les clients</strong>, sur une croisière équivalente, sans aucun frais supplémentaire et sous réserve de disponibilité.</p>
          </div>
          <ul className="space-y-2 text-slate-700">
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>État de santé ou incapacité du Capitaine ou d'un membre de l'équipage</strong> (maladie, blessure, hospitalisation, urgence médicale ou familiale) rendant impossible la conduite du navire dans des conditions de sécurité.</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Conditions météorologiques dangereuses pour la navigation</strong> (tempête, vents soutenus supérieurs à Force 7, alerte Météo-France, houle dangereuse, brouillard, orages violents, conditions empêchant l'appareillage ou la navigation en sécurité).</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Avarie technique majeure du navire</strong> survenue avant ou pendant la croisière (panne moteur, voilure endommagée, problème électrique grave, système de sécurité défaillant, anomalie certifiée par expert maritime).</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Catastrophes naturelles ou risques environnementaux</strong> (incendies maritimes ou côtiers, séismes, tsunamis, marées noires, pollutions, prolifération d'algues toxiques, fermeture de zones de baignade ou de mouillage par l'autorité maritime).</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Décisions des autorités publiques</strong> (fermeture de port, restriction de circulation maritime, interdiction de naviguer, état d'urgence, mesures sanitaires gouvernementales, contrôle douanier prolongé).</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Épidémies, pandémies et crises sanitaires</strong> nécessitant la suspension de l'activité ou le confinement.</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Grèves, mouvements sociaux et conflits</strong> (grève des ports, des transports, des douanes, des contrôleurs aériens ; émeutes, manifestations bloquant l'accès au port).</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Actes de guerre, terrorisme, piraterie</strong> ou troubles graves à l'ordre public dans la zone de navigation.</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Décisions impératives de l'autorité portuaire</strong> (refus d'accostage, fermeture d'escale, fermeture de capitainerie, indisponibilité d'un mouillage prévu).</span></li>
            <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>Cas fortuit imprévisible et insurmontable</strong> (incendie à bord, abordage, échouage non imputable au Capitaine, sinistre indépendant de la volonté de l'Organisateur).</span></li>
          </ul>
        </div>

        <p className="text-sm italic text-slate-600">Dans tous les cas listés ci-dessus, la priorité absolue de l'Organisateur est la <strong className="text-[#1D3557]">sécurité des passagers et de l'équipage</strong>. Le Capitaine est seul juge des décisions à prendre. <strong className="text-[#1D3557]">Le report jusqu'à 12 mois est systématiquement proposé aux clients</strong> et constitue la compensation principale. À défaut d'acceptation du report par le client, le remboursement interviendra dans le délai maximum de dix (10) mois précisé ci-dessus. Aucune indemnisation financière complémentaire ne pourra être réclamée à l'Organisateur au-delà. Il est <strong className="text-[#1D3557]">fortement recommandé au client de souscrire une assurance voyage</strong> couvrant les risques d'annulation, de retard et d'interruption de séjour.</p>
      </div>
    )
  },
  {
    id: 'substitution-navire', num: '14 bis', title: "Substitution de navire", icon: Ship,
    content: (
      <div className="space-y-3">
        <p>L'Organisateur se réserve expressément le droit, à tout moment avant ou pendant la croisière, de <strong className="text-[#1D3557]">substituer au navire initialement prévu un autre navire de sa flotte ou de ses partenaires affréteurs</strong>, dès lors que ce navire de remplacement permet d'assurer <strong>l'exécution substantielle des prestations contractuelles</strong>.</p>

        <p>La flotte SOGNUDIMARE est composée de plusieurs catamarans (notamment LAGOON 46, LAGOON 43 et LAGOON 38) ainsi que de navires partenaires affrétés. Tous ces navires répondent aux <strong className="text-[#1D3557]">mêmes standards de qualité, de sécurité et de confort</strong> (cabines doubles équipées, équipage professionnel, pension complète, équipements nautiques). <strong>La capacité d'accueil, le nombre de cabines, l'aménagement intérieur et les dimensions peuvent varier selon le navire effectivement affecté à la croisière</strong>, sans que ces variations ne puissent être considérées comme une diminution de prestation. Le Client reconnaît et accepte que :</p>

        <ul className="space-y-1.5 ml-3">
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong>La prestation contractuelle réside dans la croisière elle-même</strong> (itinéraire, durée, équipage, pension complète, services à bord, tarif facturé), et non dans l'identification d'un modèle, d'une marque ou d'un nom spécifique de navire.</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>Toute mention d'un modèle ou d'un nom de navire (LAGOON 46, 43, 38 ou autre) dans le bon de commande, l'offre commerciale, le site internet ou tout autre support, est fournie à <strong>titre purement indicatif et non contractuel</strong>.</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>La substitution peut intervenir <strong>entre tous les modèles de la flotte ou des navires partenaires affrétés</strong> (y compris entre LAGOON 46, 43 et 38, ou un navire d'une autre marque de gamme équivalente), sans que cela puisse être considéré comme une diminution de prestation.</span></li>
        </ul>

        <p>La disponibilité d'un navire spécifique <strong className="text-[#1D3557]">ne peut être garantie de manière absolue à la signature du présent contrat ni à toute date antérieure au départ</strong>, en raison notamment :</p>
        <ul className="space-y-1.5 ml-3">
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>des aléas techniques imprévisibles (avarie moteur, problème de gréement, panne électrique majeure, dommage matériel) ;</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>des décisions d'expertise maritime (immobilisation pour maintenance préventive ou réparation curative) ;</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>des opérations de mise en sécurité ou des contraintes liées à l'assurance du navire ;</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>de l'optimisation logistique et organisationnelle de la flotte (rotation des navires entre destinations, planification des équipages, contraintes portuaires) ;</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>des cas de force majeure visés à l'<a href="#annulation-organisateur" className="text-[#2A9D8F] hover:underline">Article 14</a> ;</span></li>
          <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>de retards de retour ou d'indisponibilité prolongée d'un navire affrété par un précédent client.</span></li>
        </ul>

        <p>La substitution éventuelle d'un navire <strong className="text-[#1D3557]">ne donne lieu à aucune indemnisation, aucun remboursement partiel, aucune remise ou compensation financière</strong>, ne constitue pas une rupture du contrat et ne peut motiver une annulation de la part du Client, dès lors que les prestations contractuelles principales (équipage, itinéraire, durée, pension complète, services à bord, hébergement en cabine double avec couchage pour le nombre de passagers initialement réservé) sont substantiellement maintenues. <strong>Le Client renonce expressément et irrévocablement</strong> à toute réclamation, contestation ou demande d'indemnisation fondée sur la seule identification du modèle, de la marque, de la longueur, du millésime, du nom, de la capacité maximale, du nombre total de cabines ou de l'aménagement intérieur du catamaran initialement mentionné, ces éléments étant exclusivement fournis à titre indicatif et descriptif. Cette renonciation est expressément acceptée par le Client à la signature du bon de commande ou par le paiement de l'acompte qui vaut acceptation des présentes CGV.</p>

        <p className="bg-[#FFF8F2] border-l-4 border-[#C4724F] p-3 rounded text-sm"><strong>Geste commercial éventuel</strong> — Dans l'esprit de qualité de service qui anime SOGNUDIMARE, l'Organisateur pourra, à son entière discrétion et sans que cela puisse être exigé par le Client, proposer un geste commercial (bouteille offerte, transfert, remise sur une future croisière, etc.) en cas de substitution exceptionnelle. Ce geste reste une faveur unilatérale et ne saurait constituer une reconnaissance d'un quelconque préjudice subi.</p>

        <p>En cas d'impossibilité totale de fourniture d'un navire dans la flotte SOGNUDIMARE ou auprès de ses partenaires affréteurs, les dispositions de l'<a href="#annulation-organisateur" className="text-[#2A9D8F] hover:underline">Article 14 (Force majeure)</a> s'appliquent : priorité au report jusqu'à 12 mois sans frais, ou à défaut, remboursement selon les modalités contractuelles prévues.</p>
      </div>
    )
  },
  {
    id: 'refus-embarquement', num: '15', title: "Refus d'embarquement", icon: Ban,
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>Retard, documents non conformes, âge, handicap non signalé, comportement dangereux, animaux non autorisés.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>Omission ou fausse déclaration sur l'état de santé : refus d'accès ou débarquement sans remboursement.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span><strong className="text-[#1D3557]">Aucun remboursement ni assistance en cas de refus.</strong></span></li>
      </ul>
    )
  },
  {
    id: 'securite-bord', num: '16', title: 'Sécurité à bord', icon: ShieldAlert,
    content: (<p>Respect absolu des consignes de sécurité et du règlement intérieur.</p>)
  },
  {
    id: 'enfants', num: '17', title: 'Enfants mineurs', icon: Baby,
    content: (<p>Acceptés sous conditions, accompagnés d'un adulte responsable.</p>)
  },
  {
    id: 'animaux', num: '18', title: 'Animaux', icon: PawPrint,
    content: (<p><strong className="text-[#1D3557]">Non admis à bord.</strong></p>)
  },
  {
    id: 'reclamations', num: '19', title: 'Réclamations', icon: MessageSquare,
    content: (<p>Doivent être adressées par écrit dans un délai de <strong className="text-[#1D3557]">7 jours</strong> après fin de la croisière.</p>)
  },
  {
    id: 'donnees-personnelles', num: '20', title: 'Données personnelles', icon: Database,
    content: (<p>Collectées uniquement pour gestion des réservations. Non transmises à des tiers.</p>)
  },
  {
    id: 'vente-en-ligne', num: '21', title: 'Vente en ligne', icon: Globe,
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><CheckCircle2 className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>La réservation en ligne implique l'acceptation intégrale des CGV.</span></li>
        <li className="flex gap-2.5"><CheckCircle2 className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Validation obligatoire via case à cocher avant paiement.</span></li>
        <li className="flex gap-2.5"><Lock className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Paiement sécurisé par carte bancaire via <strong className="text-[#1D3557]">Square</strong>, conforme aux normes PCI-DSS.</span></li>
      </ul>
    )
  },
  {
    id: 'droit-applicable', num: '22', title: 'Droit applicable et juridiction', icon: Scale,
    content: (<p>Soumis au droit français. Tout litige relève des tribunaux compétents du siège social de l'Organisateur.</p>)
  },
  {
    id: 'equipements', title: 'Equipements et activités', icon: Anchor, group: 'pratique',
    content: (
      <div className="space-y-3">
        <p>L'annexe mise à disposition est motorisée. Des masques, palmes et tubas sont fournis pour le snorkeling. Selon le navire, un paddle et/ou un kayak peuvent être mis à disposition.</p>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          <div className="bg-green-50 border border-green-200 rounded-lg p-3">
            <p className="text-green-800 text-sm font-medium mb-1">Autorisé</p>
            <p className="text-green-700 text-sm">Snorkeling, paddle, kayak, pêche (matériel fourni)</p>
          </div>
          <div className="bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-red-800 text-sm font-medium mb-1">Interdit</p>
            <p className="text-red-700 text-sm">Plongée bouteille, chasse sous-marine, kitesurf, planche à voile</p>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'embarquement', title: 'Embarquement', icon: Ship, group: 'pratique',
    content: (
      <ul className="space-y-2.5">
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Cartes d'embarquement envoyées exclusivement par email avant la date d'embarquement.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Mise à disposition des cabines du Jour 1 au Jour 7 ou 14 selon le bon de commande.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#C4724F] shrink-0 mt-1" /><span>En cas de retard important, le capitaine sera contraint d'appareiller. Aucun dédommagement.</span></li>
        <li className="flex gap-2.5"><ChevronRight className="h-4 w-4 text-[#2A9D8F] shrink-0 mt-1" /><span>Le port d'embarquement est indicatif. Le lieu précis sera sur la carte d'embarquement.</span></li>
      </ul>
    )
  },
  {
    id: 'equipage', title: "Fonctions de l'équipage", icon: Users, group: 'pratique',
    content: (
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
          <p className="font-semibold text-[#1D3557] mb-2">Capitaine</p>
          <p className="text-sm text-slate-600">Conduite du navire, entretien, formalités administratives, prises de quarts, relations avec les Autorités et les Passagers.</p>
        </div>
        <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
          <p className="font-semibold text-[#1D3557] mb-2">Marin / Hôtesse</p>
          <p className="text-sm text-slate-600">Cuisine, service, vaisselle, approvisionnements, ménage des parties communes, prises de quarts.</p>
        </div>
      </div>
    )
  },
  {
    id: 'itineraires', title: 'Itinéraires et escales', icon: Compass, group: 'pratique',
    content: (
      <div className="space-y-3">
        <p>Les itinéraires, temps de navigation et escales sont donnés à titre indicatif et peuvent être modifiés pour raisons météorologiques. Les escales « à quai » peuvent devenir « au mouillage » et inversement. Les cartes et photos de nos documentations ne sont pas contractuelles.</p>
        <p className="text-sm text-slate-600 italic">Voir <a href="#modification-itineraire" className="text-[#2A9D8F] font-medium hover:underline">Article 12 — Adaptation au changement climatique</a> : possibilité de reporter votre croisière jusqu'à 12 mois en cas de météo difficile annoncée avant l'embarquement.</p>
      </div>
    )
  },
  {
    id: 'documents-voyage', title: 'Documents de voyage', icon: FileCheck, group: 'pratique',
    content: (
      <div className="space-y-3">
        <p>Le Passager est seul responsable de la conformité des documents de voyage (passeport, visas, certificats de vaccination).</p>
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
          <p className="text-amber-800 text-sm">Photocopie des passeports à transmettre au moins <strong>10 jours</strong> avant le départ pour les navigations internationales. Signaler la présence d'enfants de moins de 12 ans au moins <strong>15 jours</strong> avant.</p>
        </div>
      </div>
    )
  },
  {
    id: 'annulation-details', title: 'Annulation et modifications', icon: CalendarX, group: 'pratique',
    content: (
      <div className="space-y-3">
        <p>Conformément à l'article L121-21-8 du Code de la consommation, les prestations ne bénéficient pas du droit de rétractation.</p>
        <p>Le paiement d'un acompte vaut acceptation de l'offre et des présentes CGV, même sans signature physique du bon de réservation.</p>
        <div className="bg-[#2A9D8F]/5 border border-[#2A9D8F]/20 rounded-xl p-4 mt-3">
          <p className="text-slate-700 text-sm font-medium">Il est vivement recommandé de souscrire une assurance voyage couvrant : annulation, rapatriement, perte de bagages, frais médicaux, accidents et assistance juridique.</p>
        </div>
      </div>
    )
  },
  {
    id: 'securite-regles', title: 'Sécurité et règles diverses', icon: ShieldAlert, group: 'pratique',
    content: (
      <div className="grid gap-3">
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-red-800 text-sm font-semibold mb-1">Substances illicites et armes</p>
          <p className="text-red-700 text-sm">Strictement interdit. Débarquement immédiat, sans remboursement.</p>
        </div>
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-red-800 text-sm font-semibold mb-1">Etat d'ébriété</p>
          <p className="text-red-700 text-sm">Refus d'embarquement ou débarquement immédiat. Aucun remboursement.</p>
        </div>
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-red-800 text-sm font-semibold mb-1">Comportement violent</p>
          <p className="text-red-700 text-sm">Débarquement immédiat. Aucun remboursement ni assistance.</p>
        </div>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          <p className="text-amber-800 text-sm font-semibold mb-1">Fumer à bord</p>
          <p className="text-amber-700 text-sm">Interdit dans toutes les parties intérieures. Zones extérieures désignées uniquement.</p>
        </div>
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
          <p className="text-slate-800 text-sm font-semibold mb-1">Equipements sportifs</p>
          <p className="text-slate-600 text-sm">Réservés aux passagers autorisés. Port du gilet de sauvetage obligatoire.</p>
        </div>
      </div>
    )
  },
  {
    id: 'departs-garantis', title: 'Départs garantis', icon: CheckCircle2, group: 'pratique',
    content: (
      <p>Les départs sont garantis quel que soit le nombre de passagers. Si le remplissage est insuffisant, le navire pourra être remplacé par un autre offrant un confort équivalent. En cas d'annulation par l'Organisateur pour causes indépendantes, remboursement intégral des sommes versées.</p>
    )
  },
  {
    id: 'retard-paiement', title: 'Retard de paiement', icon: CreditCard, group: 'pratique',
    content: (
      <p>Pénalité de <strong className="text-[#1D3557]">0,3 % par jour</strong> de retard. Après 14 jours de retard, le contrat pourra être résilié du fait du Passager, avec conservation des sommes versées et facturation des pénalités.</p>
    )
  },
  {
    id: 'conditions-particulieres', title: 'Conditions particulières', icon: FileText, group: 'pratique',
    content: (
      <div className="space-y-3">
        <h4 className="font-semibold text-[#1D3557]">Navires réservés en exclusivité</h4>
        <p>Toute modification substantielle de l'itinéraire donnera lieu à modification de tarif. Capacités : LAGOON 46 (8 passagers), LAGOON 43 (8 passagers), LAGOON 38 (8 passagers).</p>
      </div>
    )
  },
  {
    id: 'litiges', title: 'Litiges et juridiction', icon: Scale, group: 'pratique',
    content: (
      <div className="space-y-3">
        <p>Compétence exclusive attribuée aux tribunaux de Paris. Contrat régi par le droit français.</p>
        <p>Toute réclamation doit être formulée par écrit dans un délai de <strong className="text-[#1D3557]">30 jours</strong> après le débarquement.</p>
      </div>
    )
  },
];

const tocArticles = sections.filter(s => s.num);
const tocPratique = sections.filter(s => s.group === 'pratique');

const CGVPage = () => {
  const [activeSection, setActiveSection] = useState('');
  const [showToc, setShowToc] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter(e => e.isIntersecting);
        if (visible.length > 0) {
          setActiveSection(visible[0].target.id);
        }
      },
      { rootMargin: '-100px 0px -60% 0px', threshold: 0.1 }
    );
    const els = document.querySelectorAll('[data-cgv-section]');
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setShowToc(false);
    }
  };

  return (
    <Layout>
      <SEO
        title="Conditions Générales de Vente — SOGNUDIMARE"
        description="Conditions générales de vente SOGNUDIMARE pour les croisières catamaran. Engagement Climat (report 12 mois sans frais), modalités de paiement, force majeure, substitution de navire."
        path="/cgv"
        keywords={['cgv sognudimare', 'conditions générales croisière catamaran', 'engagement climat']}
      />
      {/* Hero */}
      <section className="relative pt-32 pb-12 bg-[#1D3557]" data-testid="cgv-hero">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full mb-6">
            <FileText className="h-4 w-4 text-[#2A9D8F]" />
            <span className="text-white/80 text-sm">Document contractuel</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Conditions Générales de Vente
          </h1>
          <p className="text-white/70 text-base max-w-2xl mx-auto">
            Sognudimare Catamarans — Croisières en catamaran en Corse, Grèce & Caraïbes
          </p>
        </div>
      </section>

      {/* Mobile TOC Toggle */}
      <div className="lg:hidden sticky top-[56px] z-30 bg-white border-b border-slate-200 shadow-sm">
        <button
          onClick={() => setShowToc(!showToc)}
          className="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-[#1D3557]"
          data-testid="cgv-toc-toggle"
        >
          <span className="flex items-center gap-2">
            <List className="h-4 w-4 text-[#2A9D8F]" />
            Sommaire
          </span>
          <ChevronRight className={`h-4 w-4 transition-transform ${showToc ? 'rotate-90' : ''}`} />
        </button>
        {showToc && (
          <div className="px-4 pb-4 max-h-[50vh] overflow-y-auto border-t border-slate-100">
            <nav className="space-y-1 py-2">
              {tocArticles.map(s => (
                <button key={s.id} onClick={() => scrollToSection(s.id)} className={`w-full text-left text-sm px-3 py-2 rounded-lg transition-colors ${activeSection === s.id ? 'bg-[#2A9D8F]/10 text-[#2A9D8F] font-medium' : 'text-slate-600 hover:bg-slate-50'}`}>
                  <span className="text-[#2A9D8F] font-mono mr-2">{s.num}.</span>{s.title}
                </button>
              ))}
              <div className="pt-2 mt-2 border-t border-slate-100">
                <p className="text-xs text-slate-400 uppercase tracking-wider px-3 py-1">Informations pratiques</p>
                {tocPratique.map(s => (
                  <button key={s.id} onClick={() => scrollToSection(s.id)} className={`w-full text-left text-sm px-3 py-2 rounded-lg transition-colors ${activeSection === s.id ? 'bg-[#2A9D8F]/10 text-[#2A9D8F] font-medium' : 'text-slate-600 hover:bg-slate-50'}`}>
                    {s.title}
                  </button>
                ))}
              </div>
            </nav>
          </div>
        )}
      </div>

      {/* Main Content */}
      <section className="py-10 bg-slate-50 min-h-screen" data-testid="cgv-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-10">
            {/* Desktop Sidebar TOC */}
            <aside className="hidden lg:block w-72 shrink-0">
              <div className="sticky top-24">
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 max-h-[calc(100vh-120px)] overflow-y-auto">
                  <h3 className="text-sm font-bold text-[#1D3557] uppercase tracking-wider mb-4">Sommaire</h3>
                  <nav className="space-y-0.5">
                    {tocArticles.map(s => (
                      <button key={s.id} onClick={() => scrollToSection(s.id)} className={`w-full text-left text-sm px-3 py-2 rounded-lg transition-all ${activeSection === s.id ? 'bg-[#2A9D8F]/10 text-[#2A9D8F] font-semibold' : 'text-slate-500 hover:text-[#1D3557] hover:bg-slate-50'}`}>
                        <span className="text-[#2A9D8F] font-mono text-xs mr-1.5">{s.num}.</span>{s.title}
                      </button>
                    ))}
                  </nav>
                  <div className="mt-5 pt-4 border-t border-slate-100">
                    <p className="text-xs text-slate-400 uppercase tracking-wider px-3 mb-2">Pratique</p>
                    <nav className="space-y-0.5">
                      {tocPratique.map(s => (
                        <button key={s.id} onClick={() => scrollToSection(s.id)} className={`w-full text-left text-sm px-3 py-2 rounded-lg transition-all ${activeSection === s.id ? 'bg-[#2A9D8F]/10 text-[#2A9D8F] font-semibold' : 'text-slate-500 hover:text-[#1D3557] hover:bg-slate-50'}`}>
                          {s.title}
                        </button>
                      ))}
                    </nav>
                  </div>
                </div>
              </div>
            </aside>

            {/* Content */}
            <div className="flex-1 min-w-0" ref={contentRef}>
              {/* Numbered Articles */}
              <div className="space-y-5">
                {tocArticles.map((s, i) => (
                  <div key={s.id} id={s.id} data-cgv-section className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden scroll-mt-28">
                    <div className="flex items-center gap-3 px-6 py-4 border-b border-slate-100 bg-slate-50/50">
                      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-[#2A9D8F]/10 text-[#2A9D8F] text-sm font-bold shrink-0">
                        {s.num}
                      </div>
                      <s.icon className="h-5 w-5 text-[#2A9D8F] shrink-0" />
                      <h2 className="text-lg font-bold text-[#1D3557]">{s.title}</h2>
                    </div>
                    <div className="px-6 py-5 text-slate-600 text-[15px] leading-relaxed">
                      {s.content}
                    </div>
                  </div>
                ))}
              </div>

              {/* Practical Info */}
              <div className="mt-12 mb-6">
                <h2 className="text-2xl font-bold text-[#1D3557] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>Informations pratiques</h2>
                <p className="text-slate-500 text-sm">Equipements, embarquement, équipage, itinéraires et sécurité</p>
              </div>
              <div className="space-y-5">
                {tocPratique.map((s) => (
                  <div key={s.id} id={s.id} data-cgv-section className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden scroll-mt-28">
                    <div className="flex items-center gap-3 px-6 py-4 border-b border-slate-100 bg-slate-50/50">
                      <s.icon className="h-5 w-5 text-[#2A9D8F] shrink-0" />
                      <h2 className="text-lg font-bold text-[#1D3557]">{s.title}</h2>
                    </div>
                    <div className="px-6 py-5 text-slate-600 text-[15px] leading-relaxed">
                      {s.content}
                    </div>
                  </div>
                ))}
              </div>

              {/* Back to top */}
              <div className="mt-10 text-center">
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-slate-200 rounded-full text-sm text-slate-600 hover:text-[#2A9D8F] hover:border-[#2A9D8F]/30 transition-colors shadow-sm"
                  data-testid="cgv-back-to-top"
                >
                  <ArrowUp className="h-4 w-4" />
                  Retour en haut
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CGVPage;
